import React from "react";
import { useTranslation } from "react-i18next";


const ProductFormModal = ({
  editingProduct,
  setEditingProduct,
  handleSubmit,
  closeForm,
  cities,
  suppliers,
}) => {
  const { t } = useTranslation("ProductsPage");
  if (!editingProduct) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-start overflow-y-auto">
      <div
        className="relative bg-white p-6 rounded w-full sm:w-3/4 max-w-2xl max-h-[95vh] mt-8 mb-8 overflow-y-auto shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={closeForm}
          className="absolute top-3 right-3 text-gray-500 hover:text-black text-2xl font-bold"
          type="button"
        >
          ×
        </button>

        <h2 className="text-xl font-bold mb-4">
          {editingProduct.id ? t("edit_product") : t("add_product_modal")}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-3">

          {/* NAME EN */}
          <input
            type="text"
            placeholder={t("name_en")}
            value={editingProduct.name_en || ""}
            onChange={(e) =>
              setEditingProduct({ ...editingProduct, name_en: e.target.value })
            }
            className="w-full p-2 border rounded"
            required
          />

          {/* NAME CN */}
          <input
            type="text"
            placeholder={t("name_cn")}
            value={editingProduct.name_cn || ""}
            onChange={(e) =>
              setEditingProduct({ ...editingProduct, name_cn: e.target.value })
            }
            className="w-full p-2 border rounded"
          />

          {/* COMPOSITION */}
          <textarea
            placeholder={t("composition")}
            value={editingProduct.composition || ""}
            onChange={(e) =>
              setEditingProduct({
                ...editingProduct,
                composition: e.target.value,
              })
            }
            className="w-full p-2 border rounded"
          />

          {/* IMAGE */}
          <input
            type="file"
            onChange={(e) =>
              setEditingProduct({
                ...editingProduct,
                image: e.target.files[0],
              })
            }
            className="w-full border rounded p-2"
          />

          {/* PURCHASE PRICE */}
          <input
            type="number"
            placeholder={t("purchase_price")}
            value={editingProduct.purchase_price || ""}
            onChange={(e) =>
              setEditingProduct({
                ...editingProduct,
                purchase_price: e.target.value,
              })
            }
            className="w-full p-2 border rounded"
          />

          {/* STANDARD PRICE */}
          <input
            type="number"
              placeholder={`¥ ${t("standard_price_for_new_clients")} `}
            value={editingProduct.standard_price || ""}
            onChange={(e) =>
              setEditingProduct({
                ...editingProduct,
                standard_price: e.target.value,
              })
            }
            className="w-full p-2 border rounded"
          />

          {/* CITY */}
          <select
            value={editingProduct.production_city || ""}
            onChange={(e) =>
              setEditingProduct({
                ...editingProduct,
                production_city: e.target.value,
              })
            }
            className="w-full p-2 border rounded"
          >
            <option value="">{t("production_city")}</option>
            {cities.map((city) => (
              <option key={city.id} value={city.id}>
                {city.name} ({city.country})
              </option>
            ))}
          </select>

          {/* SUPPLIER */}
          <select
            value={editingProduct.supplier_id || ""}
            onChange={(e) =>
              setEditingProduct({
                ...editingProduct,
                supplier_id: e.target.value,
              })
            }
            className="w-full p-2 border rounded"
          >
            <option value="">{t("supplier")}</option>
            {suppliers.map((s) => (
              <option key={s.id} value={s.id}>
                {s.name}
              </option>
            ))}
          </select>

          {/* BUTTONS */}
          <div className="flex justify-end space-x-2 mt-4">
            <button
              type="button"
              onClick={closeForm}
              className="px-4 py-2 bg-gray-500 text-white rounded"
            >
              {t("cancel")}
            </button>

            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded"
            >
              {t("save")}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default ProductFormModal;